import { CompanyDepositType, userSearchParams } from '../../types/resources/CompanyDepositType';
import { fetchWrapper } from '../fetchWrapper';

type GetResponseType = {
  data: {
    company_deposits: CompanyDepositType[];
  };
  headers: Record<string, string>;
};

const endpoint = '/company_deposits';

export const getCompanyDeposits = async (
  signOut: () => void,
  searchParams: userSearchParams
): Promise<GetResponseType> => {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await fetchWrapper(
    endpoint,
    {
      method: 'GET',
      queryString,
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
};

export const getCompanyDepositsCSV = async (signOut: () => void): Promise<{ data: Blob }> => {
  const response = await fetchWrapper(
    `${endpoint}.csv`,
    {
      method: 'GET',
    },
    signOut
  );
  const data = await response.blob();

  return { data };
};
